import { useTranslation } from "@coworker/locales";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import TaskCardV2 from "@coworker/apprestructured/src/task-management/components/TaskCard/TaskCard";
import ListableTaskCardWrapper from "@coworker/apprestructured/src/task-management/components/TaskCard/wrappers/NormalTaskWrapper/ListableTaskCardWrapper";
import useSearchParamState from "@coworker/apprestructured/src/shared/hooks/useSearchParamState";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import styles from "./RelatedTasksModal.module.css";

type RelatedTasksModalProps = {
  matches: Task[];
  open: boolean;
  onClose: () => void;
};

export function RelatedTasksModal({
  matches,
  open,
  onClose,
}: RelatedTasksModalProps) {
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParamState();

  return (
    <FixaModal
      visible={open}
      handleCloseBtn={onClose}
      focusLockProps={{ locked: false }}
      keepContentMounted
    >
      <FixaSheets
        labelledById="related-tasks-modal-header"
        alignment="right"
        header={
          <FixaModalHeader
            id="related-tasks-modal-header"
            title={t("relatedTasksString", { defaultValue: "Related tasks" })}
            ariaCloseTxt={t("closeString")}
          />
        }
        footer={<FixaModalFooter>{null}</FixaModalFooter>}
      >
        <FixaModalBody className={styles["content"]}>
          {matches.map((match) => (
            <div className={styles["task"]} key={match.id}>
              <ListableTaskCardWrapper
                onSelect={() => {
                  onClose();
                  setSearchParams((params) =>
                    params.set("taskViewer", match.id)
                  );
                }}
              >
                <TaskCardV2 task={match} />
              </ListableTaskCardWrapper>
            </div>
          ))}
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}
